<template>
  <div>
    <global-response-status v-if="!isStatusOk" @primaryErrorButtonFunction="retryPageMetrics"></global-response-status>
    <div v-else class="container no-padding">
      <metrics></metrics>
      <chart :pageIdentifier="pageIdentifier"></chart>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Metrics from '@/screens/Metrics/components/metrics/Metrics';
import Chart from '@/screens/Metrics/components/charts/Chart';
import GlobalResponseStatus from '@/screens/Status/StatusMain';

export default {
  data() {
    return {
      pageIdentifier: this.$route.params.pageIdentifier,
    };
  },
  created() {
    this.tryPageMetricsWhileProcessing();
  },
  components: {
    Metrics,
    Chart,
    GlobalResponseStatus,
  },
  methods: {
    ...mapActions({
      getMetrics: 'metrics/get',
      retryMetrics: 'metrics/retry',
      defineGlobalStatusFromResponseStatus: 'status/defineFromResponseStatus',
    }),
    async tryPageMetricsWhileProcessing(filters = {}) {
      const response = await this.getMetrics({ pageIdentifier: this.pageIdentifier, filters });
      this.defineGlobalStatusFromResponseStatus(response.status);

      if (this.isStatusAccepted) {
        setTimeout(async () => {
          await this.tryPageMetricsWhileProcessing();
        }, 5000);
      }
    },
    async retryPageMetrics() {
      await this.tryPageMetricsWhileProcessing({ retryPageMetrics: true });
    },
  },
  computed: mapGetters({
    isStatusOk: 'status/isOk',
    isStatusAccepted: 'status/isAccepted',
  }),
};
</script>



// WEBPACK FOOTER //
// src/screens/Metrics/components/Main.vue